var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcRotateAntihoraire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.889 16.08h14.667V1.413h-.89v13.778H.89z",
    fill: "#13123A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.351 1.965c-5.378.524-9.804 4.267-11.342 9.28",
    stroke: "#13123A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.956 11.129-2.454 2.684L.4 10.355z",
    fill: "#13123A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 .524H0v16h16z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRotateAntihoraire);
export default __webpack_public_path__ + "static/media/ic_rotate_antihoraire.ea43b9ee4a195678943cfcae8f02ad83.svg";
export { ForwardRef as ReactComponent };